(() => {
  const dialog = document.getElementById('BCContactDialog');
  if (!dialog || dialog.dataset.initialised) return;
  dialog.dataset.initialised = 'true';
  const form = dialog.querySelector('form');
  const migrationTarget = document.getElementById('migration-calculator');
  const backdrop = document.querySelector('[data-contact-submit-backdrop]');
  const submitStatus = dialog.querySelector('[data-contact-submit-status]');
  const submitRetry = dialog.querySelector('[data-contact-submit-retry]');
  let submitting = false, submitTimer = 0, submitSequence = 0;
  const contextKey = 'bc-contact-submission-v1';
  const eligibleRanges = new Set(['20K-50K EUR', '50K-100K EUR', '100K-500K EUR', 'More than 500K EUR']);
  const maxContextAge = 30 * 60 * 1000;
  let opener = null, scrollBefore = '', pendingOpen = 0;
  const readContext = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(contextKey) || 'null');
      return value && value.path === location.pathname && Date.now() - value.created >= 0 && Date.now() - value.created < maxContextAge ? value : null;
    } catch (_) { return null; }
  };
  const forgetContext = () => { try { sessionStorage.removeItem(contextKey); } catch (_) {} };
  const isContact = link => {
    if (link.hasAttribute('data-bc-menu')) return false;
    if (link.hasAttribute('data-bc-contact')) return true;
    try { const url = new URL(link.getAttribute('href'), location.href); return url.origin === location.origin && /\/pages\/contact\/?$/.test(url.pathname); }
    catch (_) { return false; }
  };
  const normaliseLinks = scope => {
    scope.querySelectorAll('a[href],button[data-bc-contact]').forEach(link => {
      if (!isContact(link)) return;
      link.setAttribute('data-bc-contact', '');
      if (link.tagName === 'A') link.setAttribute('href', migrationTarget ? '#migration-calculator' : '#contact');
      // Placeholder menu cards keep their navigation names, even if they currently lead to contact.
      if (link.matches('.bc-nav__menu-link,.bc-nav__mobile-sub a')) return;
      const label = dialog.dataset.contactLabel;
      if (!label || link.textContent.trim() === label) return;
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, { acceptNode: node => node.parentElement.closest('svg,.visually-hidden') || !node.textContent.trim() ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT });
      const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
      if (nodes.length) { nodes[0].textContent = label; nodes.slice(1).forEach(node => node.textContent = ''); }
      else link.prepend(document.createTextNode(label));
      if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', label);
    });
  };
  const open = target => {
    if (migrationTarget) {
      migrationTarget.focus({ preventScroll:true });
      migrationTarget.scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start' });
      return;
    }
    if (dialog.open) return;
    opener = target || null;
    scrollBefore = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  };
  const openFromLink = link => {
    clearTimeout(pendingOpen);
    const mobile = document.querySelector('dialog.bc-nav__mobile[open]');
    if (mobile) {
      mobile.querySelector('[data-bc-close]')?.click();
      pendingOpen = setTimeout(() => open(link), 360);
    } else open(link);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href],button[data-bc-contact]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || !isContact(link)) return;
    event.preventDefault(); openFromLink(link);
  });
  dialog.querySelector('[data-contact-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    // A valid submit yields the top layer to Shopify's external verification UI.
    // Its queued close event must not undo the still-open modeless dialog.
    if (dialog.open) return;
    submitting = false; submitSequence++; clearTimeout(submitTimer);
    delete dialog.dataset.submitting;
    dialog.removeAttribute('aria-modal');
    if (backdrop) backdrop.hidden = true;
    if (submitStatus) submitStatus.hidden = true;
    if (submitRetry) submitRetry.hidden = true;
    const button = form?.querySelector('[type="submit"]');
    if (button) { button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled'); }
    document.body.style.overflow = scrollBefore;
    if (opener?.isConnected && opener.getClientRects().length) opener.focus({ preventScroll: true });
  });
  form?.addEventListener('submit', event => {
    if (!form.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (submitting) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    const message = form.querySelector('[name="contact[body]"]');
    if (!message?.value.trim()) { event.preventDefault(); event.stopImmediatePropagation(); message?.setCustomValidity(dialog.dataset.messageRequired); message?.reportValidity(); return; }
    const eligible = eligibleRanges.has(form.querySelector('[name="contact[monthly_revenue]"]')?.value);
    const context = { eligible, path: location.pathname, created: Date.now() };
    if (eligible) { context.name = form.querySelector('[name="contact[name]"]')?.value.trim(); context.email = form.querySelector('[name="contact[email]"]')?.value.trim(); }
    try { sessionStorage.setItem(contextKey, JSON.stringify(context)); } catch (_) {}
    // Preserve the native Shopify POST, validation and anti-spam flow. Only a non-personal qualification flag goes in the return URL.
    const returnField = form.querySelector('[name="return_to"]');
    if (returnField) { const back = new URL(location.href); back.searchParams.set('contact_posted', 'true'); back.searchParams.set('bc_contact_booking', eligible ? '1' : '0'); back.hash = 'BCContactForm'; returnField.value = back.pathname + back.search + back.hash; }
    submitting = true;
    const sequence = ++submitSequence;
    const button = form.querySelector('[type="submit"]');
    // Do not disable the native submitter: Shopify owns the protected POST.
    if (button) { button.setAttribute('aria-busy', 'true'); button.setAttribute('aria-disabled', 'true'); }
    if (submitStatus) submitStatus.hidden = false;
    if (submitRetry) submitRetry.hidden = true;
    // hCaptcha places its challenge outside our dialog. Keeping showModal() here
    // makes that frame inert and can leave the submission silently waiting.
    dialog.dataset.submitting = 'true';
    dialog.close();
    dialog.show();
    dialog.setAttribute('aria-modal', 'false');
    if (backdrop) backdrop.hidden = false;
    clearTimeout(submitTimer);
    submitTimer = setTimeout(() => {
      submitting = false;
      if (button) { button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled'); }
      if (submitStatus) submitStatus.hidden = true;
      if (submitRetry) submitRetry.hidden = false;
    }, 30000);
    // Shopify cancels a first submit while its provider is still binding. Wait
    // for the official ready callback and replay the same native submission.
    if (!form.dataset.hcaptchaBound && !form.dataset.recaptchaBound && window.Shopify?.captcha?.protect) {
      event.preventDefault(); event.stopImmediatePropagation();
      window.Shopify.captcha.protect(form, () => {
        if (sequence !== submitSequence || !dialog.open) return;
        submitting = false;
        form.requestSubmit(button);
      });
    }
  });
  form?.querySelector('[name="contact[body]"]')?.addEventListener('input', event => event.target.setCustomValidity(''));
  window.addEventListener('pageshow', event => { if (event.persisted) { submitting = false; submitSequence++; clearTimeout(submitTimer); if (submitStatus) submitStatus.hidden = true; if (submitRetry) submitRetry.hidden = true; } const button = form?.querySelector('[type="submit"]'); if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled'); } });

  const showCalendar = context => {
    const booking = dialog.querySelector('[data-contact-booking]');
    const host = dialog.querySelector('[data-contact-calendar]');
    if (!booking || !host) return;
    booking.hidden = false;
    dialog.dataset.step = 'booking';
    const load = dialog.querySelector('[data-calendar-loading]');
    const failed = dialog.querySelector('[data-calendar-failed]');
    let calendarTimer, fallbackFrame = null;
    const fail = () => {
      clearTimeout(calendarTimer);
      if (fallbackFrame) { load.hidden = true; failed.hidden = false; host.setAttribute('aria-busy', 'false'); return; }
      // The booking page remains usable if the SDK's cross-frame handshake fails.
      // Keep the real Cal.com booking UI embedded instead of an endless spinner.
      const url = new URL('https://cal.com/marc-momplet-aycdqn/black-comet');
      url.searchParams.set('layout', 'month_view');
      url.searchParams.set('theme', 'dark');
      url.searchParams.set('locale', document.documentElement.lang.split('-')[0]);
      if (context?.name) url.searchParams.set('name', context.name);
      if (context?.email) url.searchParams.set('email', context.email);
      fallbackFrame = document.createElement('iframe');
      fallbackFrame.title = booking.dataset.calendarTitle;
      fallbackFrame.className = 'bc-contact__calendar-fallback';
      fallbackFrame.referrerPolicy = 'strict-origin-when-cross-origin';
      fallbackFrame.addEventListener('load', () => {
        clearTimeout(calendarTimer); load.hidden = true; failed.hidden = true; host.setAttribute('aria-busy', 'false');
      }, { once: true });
      fallbackFrame.addEventListener('error', fail, { once: true });
      fallbackFrame.src = url.href;
      host.replaceChildren(fallbackFrame);
      load.hidden = false; failed.hidden = true;
      calendarTimer = setTimeout(fail, 20000);
    };
    calendarTimer = setTimeout(fail, 8000);
    try {
    // Cal's official queued snippet is loaded only after a successful, qualified enquiry.
    if (!window.Cal) {
      const push = (api, args) => api.q.push(args);
      window.Cal = function () {
        const api = window.Cal, args = arguments;
        if (!api.loaded) { api.ns = {}; api.q = api.q || []; api.loaded = true; const script = document.createElement('script'); script.src = 'https://app.cal.com/embed/embed.js'; script.async = true; script.onerror = fail; document.head.appendChild(script); }
        if (args[0] === 'init') { const namespace = args[1]; const apiForNamespace = function () { push(apiForNamespace, arguments); }; apiForNamespace.q = apiForNamespace.q || []; if (typeof namespace === 'string') { api.ns[namespace] = api.ns[namespace] || apiForNamespace; push(api.ns[namespace], args); push(api, ['initNamespace', namespace]); } else push(api, args); return; }
        push(api, args);
      };
    }
    const namespace = 'black-comet-contact';
    window.Cal('init', namespace, { origin: 'https://cal.com' });
    const cal = window.Cal.ns[namespace];
    const ready = () => { if (fallbackFrame) return; clearTimeout(calendarTimer); load.hidden = true; failed.hidden = true; host.setAttribute('aria-busy', 'false'); };
    cal('on', { action: 'linkReady', callback: ready });
    cal('on', { action: 'linkFailed', callback: fail });
    cal('inline', { elementOrSelector: host, calLink: 'marc-momplet-aycdqn/black-comet', config: { layout: 'month_view', theme: 'dark', locale: document.documentElement.lang.split('-')[0], name: context?.name || '', email: context?.email || '', iframeAttrs: { title: booking.dataset.calendarTitle } } });
    cal('ui', { theme: 'dark', hideEventTypeDetails: true, layout: 'month_view', disableAutoScroll: true, cssVarsPerTheme: { dark: { 'cal-bg': '#181818', 'cal-bg-emphasis': '#252525', 'cal-bg-subtle': '#202020', 'cal-bg-muted': '#181818', 'cal-border': '#303030', 'cal-border-subtle': '#303030', 'cal-border-booker': '#303030', 'cal-brand': '#ffffff', 'cal-brand-emphasis': '#dddddd', 'cal-brand-text': '#121212', 'cal-text': '#cccccc', 'cal-text-emphasis': '#ffffff', 'cal-text-subtle': '#999999', radius: '12px' } } });
    } catch (_) { fail(); }
  };
  const migrationReply = new URL(location.href).searchParams.get('bc_migration') === '1' && !!document.querySelector('bc-migration-calculator');
  const resourceReply = !!document.querySelector('[data-resource-library][data-resource-response]') || (new URL(location.href).searchParams.has('bc_resource') && !!document.querySelector('[data-resource-library] [data-resource-success], [data-resource-library] [data-resource-errors]'));
  const success = dialog.querySelector('[data-contact-success]');
  if (success && !migrationReply && !resourceReply) {
    const context = readContext();
    const flag = new URL(location.href).searchParams.get('bc_contact_booking');
    const eligible = flag === '1' || (flag === null && context?.eligible === true);
    forgetContext();
    if (eligible) showCalendar(context);
    const clean = new URL(location.href); clean.searchParams.delete('bc_contact_booking'); clean.searchParams.delete('contact_posted'); if (clean.hash === '#BCContactForm') clean.hash = ''; history.replaceState(null, '', clean.pathname + clean.search + clean.hash);
    open(null);
  } else if (!migrationReply && !resourceReply && dialog.querySelector('[data-contact-response]')) {
    open(null);
  }
  if (migrationReply) {
    const clean = new URL(location.href); clean.searchParams.delete('bc_migration'); clean.searchParams.delete('contact_posted'); history.replaceState(null, '', clean.pathname + clean.search + clean.hash);
  }
  // Discard legacy return markers that have no confirmed Shopify response.
  // They must not keep following visitors around or imply a successful send.
  const legacyReturn = new URL(location.href);
  if (!migrationReply && !resourceReply && !dialog.querySelector('[data-contact-response]') && legacyReturn.searchParams.has('bc_contact_booking')) {
    legacyReturn.searchParams.delete('bc_contact_booking');
    if (legacyReturn.hash === '#BCContactForm') legacyReturn.hash = '';
    history.replaceState(null, '', legacyReturn.pathname + legacyReturn.search + legacyReturn.hash);
    forgetContext();
  }
  const start = () => {
    normaliseLinks(document);
    const route = document.querySelector('[data-bc-contact-route]');
    if (route) { const home = new URL(route.dataset.contactHome, location.origin); const preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) home.searchParams.set('preview_theme_id', preview); home.hash = 'contact'; location.replace(home.href); return; }
    if (location.hash === '#contact') { open(null); const clean = new URL(location.href); clean.hash = ''; history.replaceState(null, '', clean.pathname + clean.search); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', event => normaliseLinks(event.target));
  window.addEventListener('hashchange', () => { if (location.hash === '#contact') open(null); });
})();
